"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayDoc = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../components");
var Customize_1 = require("./Customize");
var Display_1 = require("./Display");
var DisplayDoc = function () { return (react_1.default.createElement(components_1.Doc, { title: "Display" },
    react_1.default.createElement(Display_1.Display, null),
    react_1.default.createElement(Customize_1.DisplayCustomize, null))); };
exports.DisplayDoc = DisplayDoc;
